import Component from '@glimmer/component';
import { PrismAccordion, PrismBadge } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

interface HotelPricingAssistantDayDetailTabsRecommendationReasonAccordionSignature {
  Args: {
    reason: {
      icon: IconName;
      isIncrease: boolean | null;
      label: string;
    };
  };
  Blocks: {
    default: [];
  };
}

export default class HotelPricingAssistantDayDetailTabsRecommendationReasonAccordion extends Component<HotelPricingAssistantDayDetailTabsRecommendationReasonAccordionSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get badgeDetails() {
    return {
      type: this.args.reason.isIncrease ? 'success' : 'danger',
      icon: this.args.reason.isIncrease ? 'trending-up' : 'trending-down',
    } as const;
  }

  get showBadge(): boolean {
    // In case of fallback reason, we don't show any badge. So BE sends isIncrease as null in that case.
    return this.args.reason.isIncrease !== null;
  }

  <template>
    <PrismAccordion @description={{@reason.label}} @icon={{@reason.icon}}>
      <:summaryAfter>
        {{#if this.showBadge}}
          <PrismBadge
            @iconName={{this.badgeDetails.icon}}
            @label=""
            @type={{this.badgeDetails.type}}
          />
        {{/if}}
      </:summaryAfter>
      <:default>{{yield}}</:default>
    </PrismAccordion>
  </template>
}
